// extracted by mini-css-extract-plugin
module.exports = {"matchCentreMatchStats":"matchCentreMatchStats_matchCentreMatchStats__04cdP"};